import axios from "axios";
import { tokenStorage } from "../utils/tokenStorage";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach the auth token (X-My-Secret-Token) to every request, same header
// contract the original jQuery app used.
api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers["X-My-Secret-Token"] = token;
  }
  return config;
});

// Surface the real backend error in the console instead of swallowing it -
// makes 500s / CORS issues much faster to diagnose in production.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error(
        `[API] ${error.config?.method?.toUpperCase()} ${error.config?.url} -> ${error.response.status}`,
        error.response.data
      );
    } else {
      console.error("[API] Request failed (no response - likely CORS/network):", error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
